import { render, staticRenderFns } from "./AlignLeftIcon.vue?vue&type=template&id=61833840&"
import script from "./AlignLeftIcon.vue?vue&type=script&lang=js&"
export * from "./AlignLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports